/** Dicionário em inglês: mesmas chaves e formas de `pt-BR.ts`. */
export const en = {
    // --- Global
    'global.carregando': 'Loading…',
    'global.fechar': 'Close',
    'global.cancelar': 'Cancel',
    'global.confirmar': 'Confirm',
    'global.sim': 'Yes',
    'global.nao': 'No',
    // --- Language selector
    'idioma.grupo': 'Language',
    'idioma.opcaoPt': 'Portuguese (Brazil)',
    'idioma.opcaoEn': 'English',
    // --- Generic interface errors (known HTTP client categories)
    'erro.falhaDeRede': 'Could not reach the Geo-Engine. Check the configured address and CORS settings.',
    'erro.status401': 'Missing or invalid token. Provide a valid token to continue.',
    'erro.status404': 'Resource not found in the Geo-Engine.',
    'erro.status503': 'Geo-Engine is currently unavailable.',
    'erro.respostaInesperada': 'The Geo-Engine responded {status} without the expected error contract.',
    // @@FRAGMENTO:global@@
    // --- Header and navigation
    'cabecalho.usuarioAutenticado': 'Signed-in user',
    'cabecalho.rotuloUsuario': 'User',
    'cabecalho.menuUsuario': 'User menu',
    'cabecalho.perfil': 'Profile',
    'cabecalho.configuracoes': 'Settings',
    'cabecalho.sair': 'Sign out',
    'navegacao.principal': 'Main navigation',
    'navegacao.inicio': 'Home',
    'navegacao.ingestao': 'Ingestion',
    'navegacao.viewer': 'Viewer',
    'navegacao.recolherMenu': 'Collapse side menu',
    'navegacao.expandirMenu': 'Expand side menu',
    'navegacao.recolher': 'Collapse',
    'navegacao.expandir': 'Expand',
    // --- Home
    'home.titulo': 'DFP Agro Operations Dashboard',
    'home.subtitulo': 'Geospatial data management, ingestions and territorial visualization.',
    'home.apresentacao': 'Institutional overview',
    'home.modulos': 'Platform modules',
    'home.ingestao.categoria': 'Operational module',
    'home.ingestao.titulo': 'Data ingestion',
    'home.ingestao.descricao': 'Manage incorporations, track runs and browse published layers.',
    'home.ingestao.acao': 'Go to ingestion',
    'home.viewer.categoria': 'Territorial visualization',
    'home.viewer.titulo': 'Viewer',
    'home.viewer.descricao': 'Explore the geospatial layers made available by the Geo-Engine.',
    'home.viewer.acao': 'Open Viewer',
    'home.capacidades.rotulo': 'Platform capabilities',
    'home.capacidades.titulo': 'Geospatial platform',
    'home.capacidades.subtitulo': 'Capabilities exposed by the Geo-Engine across the full lifecycle of territorial data.',
    'home.capacidades.ingestao.titulo': 'Vector ingestion',
    'home.capacidades.ingestao.texto': 'Incorporation of geospatial files with validation, domain profile and controlled publication.',
    'home.capacidades.ingestao.meta': 'Shapefile and GeoPackage sources',
    'home.capacidades.publicacao.titulo': 'Layer publication',
    'home.capacidades.publicacao.texto': 'Data made available to the Geo-Engine APIs, with versioning and persisted provenance.',
    'home.capacidades.publicacao.meta': 'REST and MVT APIs',
    'home.capacidades.exploracao.titulo': 'Territorial exploration',
    'home.capacidades.exploracao.texto': 'Cartographic visualization of published layers, with selection, inspection and spatial operations.',
    'home.capacidades.exploracao.meta': 'Map, attributes, geometry',
    'home.rodape': 'DFP Agro Platform · Geo-Engine Operational',
    // --- Login
    'login.titulo': 'Geo-Engine',
    'login.subtitulo': 'Operational Interface access',
    'login.usuario': 'Username',
    'login.senha': 'Password',
    'login.entrar': 'Sign in',
    'login.entrando': 'Signing in…',
    'login.erroCredenciais': 'Invalid username or password.',
    'login.erroConexao': 'Could not sign in. Check your connection and try again.',
    // --- Connection indicator
    'saude.inalcancavel': 'Unreachable',
    'saude.indisponivel': 'Unavailable',
    'saude.verificando': 'Checking',
    'saude.conexao': 'Connection',
    'saude.conectado': 'Connected',
    'saude.degradado': 'Degraded',
    'saude.tituloSemResposta': 'Environment {ambiente}. Click to check again.',
    'saude.titulo': 'Geo-Engine {versao} · database {banco} · environment {ambiente}. Click to check again.',
    // --- Technical diagnostics
    'diagnostico.titulo': 'Technical diagnostics',
    'diagnostico.ultimaChamada': 'Last call',
    'diagnostico.fechar': 'Close technical diagnostics',
    'diagnostico.vazio': 'No call recorded in this session.',
    'diagnostico.metodo': 'Method',
    'diagnostico.endpoint': 'Endpoint',
    'diagnostico.status': 'Status',
    'diagnostico.semResposta': 'no response',
    'diagnostico.duracao': 'Duration',
    'diagnostico.horario': 'Time',
    // --- Contextual selection of overlapping features
    'seletorContextual.titulo': 'Features at this location',
    'seletorContextual.subtitulo': 'Select the feature you want to inspect.',
    'seletorContextual.fechar': 'Close feature selection',
    // @@FRAGMENTO:ingestao@@
    'ingestao.acao.fechar': 'Close',
    'ingestao.acao.cancelar': 'Cancel',
    'ingestao.status.emExecucao': 'Running',
    'ingestao.status.concluida': 'Completed',
    'ingestao.status.parcial': 'Partial',
    'ingestao.status.falhou': 'Failed',
    'ingestao.status.cancelada': 'Cancelled',
    'ingestao.status.pendente': 'Pending',
    'ingestao.pagina.titulo': 'Ingestion',
    'ingestao.pagina.subtitulo': 'Submit, monitor and delete ingestion runs.',
    'ingestao.pagina.novaIngestao': 'New ingestion',
    'ingestao.detalhes.titulo': 'Run details',
    'ingestao.detalhes.carregando': 'Loading run data…',
    'ingestao.detalhes.rotuloStatus': 'Status',
    'ingestao.detalhes.rotuloInicio': 'Started',
    'ingestao.detalhes.rotuloTermino': 'Finished',
    'ingestao.detalhes.rotuloLidos': 'Records read',
    'ingestao.detalhes.rotuloValidos': 'Valid records',
    'ingestao.detalhes.rotuloRejeitados': 'Rejected records',
    'ingestao.detalhes.rotuloMensagem': 'Message',
    'ingestao.detalhes.rotuloEvidencias': 'Validation evidence',
    'ingestao.detalhes.atualizando': ' · updating…',
    'ingestao.detalhes.acompanhamento': 'Monitoring in the background — data is updated automatically.',
    'ingestao.consulta.falhaGenerica': 'Could not retrieve the run.',
    'ingestao.exclusao.titulo': 'Permanently delete ingestion?',
    'ingestao.exclusao.excluindo': 'Deleting…',
    'ingestao.exclusao.confirmar': 'Delete permanently',
    'ingestao.exclusao.execucaoSelecionada': 'Selected run',
    'ingestao.exclusao.aviso': 'This operation is {irreversivel} and will permanently remove the records and publications associated with this run, including any published layers.',
    'ingestao.exclusao.irreversivel': 'irreversible',
    'ingestao.exclusao.falhaGenerica': 'Could not delete the ingestion.',
    'ingestao.exclusao.atualizacaoFalhou': 'The ingestion was deleted, but refreshing the interface failed ({falhas}). Reload the page to synchronize.',
    'ingestao.exclusao.falhaHistorico': 'history: {detalhe}',
    'ingestao.exclusao.falhaCatalogo': 'catalog: {detalhe}',
    'ingestao.exclusao.falhaDesconhecida': 'unknown failure',
    'ingestao.catalogo.regiao': 'Published layers catalog',
    'ingestao.catalogo.titulo': 'Published layers',
    'ingestao.catalogo.consultando': 'Loading the catalog…',
    'ingestao.catalogo.vazioTitulo': 'No layers',
    'ingestao.catalogo.vazioTexto': 'No operational layer has been published yet.',
    'ingestao.catalogo.colIdentidade': 'Public identifier',
    'ingestao.catalogo.colNome': 'Name',
    'ingestao.catalogo.colGeometria': 'Geometry',
    'ingestao.catalogo.colFeicoes': 'Features',
    'ingestao.catalogo.colCrs': 'Source CRS',
    'ingestao.execucao.regiao': 'Selected run details',
    'ingestao.execucao.titulo': 'Selected run',
    'ingestao.execucao.nenhumaTitulo': 'No run selected',
    'ingestao.execucao.nenhumaTexto': 'Select a row in the history to see the details.',
    'ingestao.execucao.consultando': 'Loading the run…',
    'ingestao.execucao.falhaTitulo': 'Query failure',
    'ingestao.execucao.acompanhando': 'Monitoring…',
    'ingestao.historico.titulo': 'Ingestion history',
    'ingestao.historico.subtitulo': 'Follow the runs and their results.',
    'ingestao.historico.paginaDeTotal': 'Page {atual} of {total}',
    'ingestao.historico.consultando': 'Loading the history…',
    'ingestao.historico.vazioTitulo': 'No ingestions',
    'ingestao.historico.vazioTexto': 'No ingestion run has been recorded yet.',
    'ingestao.historico.tabela': 'Ingestions table',
    'ingestao.historico.colDataset': 'Dataset',
    'ingestao.historico.colLidos': 'Read',
    'ingestao.historico.colValidos': 'Valid',
    'ingestao.historico.colRejeitados': 'Rejected',
    'ingestao.historico.colCamada': 'Published layer',
    'ingestao.historico.colAcoes': 'Actions',
    'ingestao.historico.excluirIndisponivel': 'Deletion unavailable until the ingestion finishes',
    'ingestao.historico.excluirRotulo': 'Delete ingestion {nome}',
    'ingestao.historico.excluirAguarde': 'Wait for completion to delete this ingestion.',
    'ingestao.historico.excluirDica': 'Permanently delete this ingestion.',
    'ingestao.historico.excluir': 'Delete',
    'ingestao.historico.navegacao': 'History navigation',
    'ingestao.historico.paginaAnterior': 'Previous page',
    'ingestao.historico.registrosNestaPagina': { um: '{contagem} record on this page', outros: '{contagem} records on this page' },
    'ingestao.historico.exibindoAPartirDe': 'Showing from {inicio}',
    'ingestao.historico.proximaPagina': 'Next page',
    'ingestao.formulario.erroSemArquivo': 'Select a .zip or .gpkg file.',
    'ingestao.formulario.erroExtensao': 'The file must have a .zip or .gpkg extension.',
    'ingestao.formulario.erroSemPerfil': 'Without a profile, provide the public identifier (public_id) and the layer name.',
    'ingestao.formulario.erroTerritorial': 'The territorial-v1 profile requires the territorial type and the name field.',
    'ingestao.formulario.erroEnvio': 'Could not submit the ingestion.',
    'ingestao.formulario.titulo': 'New ingestion',
    'ingestao.formulario.subtitulo': 'Configure and submit a geospatial data source.',
    'ingestao.formulario.fonteTitulo': 'Data source',
    'ingestao.formulario.fonteDescricao': 'Select the file containing the geospatial data to be processed.',
    'ingestao.formulario.selecioneArquivo': 'Select a geospatial file',
    'ingestao.formulario.formatosAceitos': 'Accepted formats: .zip and .gpkg',
    'ingestao.formulario.substituirArquivo': 'Click to replace the file',
    'ingestao.formulario.configTitulo': 'Ingestion settings',
    'ingestao.formulario.configDescricao': 'Define the processing profile and, when needed, the source layer.',
    'ingestao.formulario.perfil': 'Ingestion profile',
    'ingestao.formulario.semPerfil': 'No profile (generic technical validation)',
    'ingestao.formulario.camadaDaFonte': 'Source layer',
    'ingestao.formulario.camadaDaFonteAuxilio': 'Only needed if the file has more than one layer.',
    'ingestao.formulario.tipoTerritorial': 'Territorial type',
    'ingestao.formulario.campoNome': 'Field with the unit name',
    'ingestao.formulario.campoAreaOrigem': 'Field with the source area (optional)',
    'ingestao.formulario.publicacaoTitulo': 'Layer publication',
    'ingestao.formulario.publicacaoDescricao': 'Information shown publicly after the ingestion completes.',
    'ingestao.formulario.identidade': 'Public identifier',
    'ingestao.formulario.identidadeObrigatoria': 'Public identifier — required without a profile',
    'ingestao.formulario.nomePublico': 'Public name',
    'ingestao.formulario.nomePublicoObrigatorio': 'Public name — required without a profile',
    'ingestao.formulario.descricao': 'Description (optional)',
    'ingestao.formulario.finalidade': 'Purpose (optional)',
    'ingestao.formulario.atributosMvt': 'Publishable MVT attributes, comma-separated (optional)',
    'ingestao.formulario.enviando': 'Submitting…',
    'ingestao.formulario.iniciar': 'Start ingestion',
    // @@FRAGMENTO:mapa@@
    'mapa.controlesCartograficos': 'Additional cartographic controls',
    'mapa.desativarRelevoSombreado': 'Turn off shaded relief',
    'mapa.ativarRelevoSombreado': 'Turn on shaded relief',
    'mapa.alternarRelevoSombreado': 'Toggle shaded relief',
    'mapa.regiao': 'Map',
    'mapa.avisoSemBasemapAntes': 'No basemap configured. Geo-Engine layers are still drawn over a neutral background. Set ',
    'mapa.avisoSemBasemapDepois': ' to use a basemap.',
    'mapa.catalogoDeCamadas': 'Layer catalog',
    'mapa.camadas': 'Layers',
    'mapa.consultarCatalogoNovamente': 'Query the catalog again',
    'mapa.consultandoCatalogo': 'Querying the catalog…',
    'mapa.nenhumaCamada': 'No layers',
    'mapa.catalogoVazio': 'Geo-Engine has not published any layers in the catalog.',
    'mapa.ativarCamada': 'Enable {nome}',
    'mapa.recolher': 'Collapse',
    'mapa.expandir': 'Expand',
    'mapa.recolherCamada': 'Collapse {nome}',
    'mapa.expandirCamada': 'Expand {nome}',
    'mapa.carregandoTiles': 'Loading tiles',
    'mapa.falhaDeTiles': 'Failed to load the layer tiles.',
    'mapa.erro': 'error',
    'mapa.tipoNaoSuportado': 'unsupported type',
    'mapa.enquadrar': 'Zoom to layer',
    'mapa.ocultarConfiguracoes': 'Hide settings',
    'mapa.configuracoes': 'Settings',
    'medicao.titulo': 'Cartographic measurement',
    'medicao.medirDistancia': 'Measure distance',
    'medicao.medirArea': 'Measure area',
    'medicao.instrucaoDistancia': 'Click the map to add vertices. At least two.',
    'medicao.instrucaoArea': 'Click the map to add vertices. At least three.',
    'medicao.vertices': 'Vertices: {quantidade}',
    'medicao.distanciaParcial': 'Partial distance: {valor}',
    'medicao.areaParcial': 'Partial area: {area} · Perimeter: {perimetro}',
    'medicao.erro.coordenadasInvalidas': 'Invalid coordinates: use longitude between -180° and 180° and latitude between -90° and 90°.',
    'medicao.erro.minimoDoisVertices': 'Mark at least two vertices to measure the distance.',
    'medicao.erro.minimoTresVertices': 'Mark at least three distinct vertices to measure the area.',
    'medicao.erro.verticesRepetidos': 'The polygon has repeated vertices.',
    'medicao.erro.autoIntersecao': 'The polygon crosses itself: redraw it without self-intersection.',
    'medicao.erro.poligonoDegenerado': 'The polygon is degenerate: the calculated area is zero.',
    'medicao.concluir': 'Finish',
    'medicao.cancelar': 'Cancel',
    'medicao.limpar': 'Clear',
    'medicao.resultadoAria': 'Cartographic measurement result',
    'medicao.tituloResultado': 'Cartographic measurement — estimate',
    'medicao.distanciaTotal': 'Total distance: {valor}',
    'medicao.area': 'Area: {valor}',
    'medicao.perimetro': 'Perimeter: {valor}',
    'medicao.nota': 'Spherical geodesic estimate. It is not an official or cadastral measurement.',
    'medicao.exportarGeoJson': 'Export GeoJSON',
    'relevo.titulo': 'Relief',
    'relevo.hillshade': 'Hillshade',
    'relevo.intensidade': 'Hillshade intensity',
    'buffer.geometriaNaoObtida': 'The feature geometry has not yet been retrieved from Geo-Engine.',
    'buffer.titulo': 'Buffer distance',
    'buffer.descricao': 'Set the expansion distance in meters.',
    'buffer.distanciaEmMetros': 'Distance in meters',
    'buffer.auxilio': 'Geo-Engine validates the distance provided.',
    'buffer.calcular': 'Calculate buffer',
    'buffer.limpar': 'Clear',
    'buffer.processando': 'Processing in Geo-Engine…',
    'buffer.resultado': 'Buffer result',
    'buffer.operacaoProcessada': 'Operation processed by Geo-Engine',
    'buffer.distanciaAplicada': 'Applied distance',
    'buffer.valorEmMetros': '{valor} m',
    'buffer.geometria': 'Geometry',
    'legenda.titulo': 'Legend',
    'legenda.camadasNoMapa': 'Layers on the map',
    'legenda.feicaoSelecionada': 'Selected feature',
    'legenda.resultadoDeOperacao': 'Operation result',
    'legenda.hipsometrica.aria': 'Terrain elevation legend',
    'legenda.hipsometrica.titulo': 'Terrain elevation',
    'legenda.hipsometrica.subtitulo': 'Altitude in meters',
    'legenda.hipsometrica.metros': '{valor} m',
    'legenda.hipsometrica.metrosOuMais': '{valor}+ m',
    'legenda.hipsometrica.nota': 'Hypsometric base · DEM',
    // @@FRAGMENTO:exploracao@@
    // --- Exploration (panel, catalog, navigation)
    'exploracao.titulo': 'Territorial exploration',
    'exploracao.painel': 'Territorial exploration panel',
    'exploracao.reabrirPainel': 'Reopen panel',
    'exploracao.reabrirPainelNome': 'Reopen territorial exploration panel',
    'exploracao.catalogo': 'Catalog',
    'exploracao.rotuloExploracao': 'Exploration',
    'exploracao.feicoesDaCamada': 'Layer features',
    'exploracao.detalhesDaFeicao': 'Feature details',
    'exploracao.recolherPainel': 'Collapse panel',
    'exploracao.voltarListaFeicoes': 'Back to feature list',
    'exploracao.fecharInspecao': 'Close inspection',
    'exploracao.voltarCatalogoCamadas': 'Back to layer catalog',
    'exploracao.ativarCamada': 'Activate {nome}',
    'exploracao.quantidadePublicadas': { um: '{quantidade} published feature', outros: '{quantidade} published features' },
    'exploracao.recolherCamada': 'Collapse layer',
    'exploracao.expandirCamada': 'Expand layer',
    'exploracao.recolher': 'Collapse',
    'exploracao.expandir': 'Expand',
    'exploracao.tilesCarregando': 'loading tiles',
    'exploracao.tilesErro': 'failed to load tiles',
    'exploracao.tilesErroComMensagem': 'failed to load tiles: {mensagem}',
    'exploracao.geometriaNaoSuportada': 'unsupported geometry ({tipo})',
    'exploracao.explorarFeicoes': 'Explore features',
    'exploracao.enquadrarCamada': 'Fit {nome} to map',
    'exploracao.enquadrarNoMapa': 'Fit to map',
    'exploracao.enquadrar': 'Fit to map',
    'exploracao.configuracoesDe': 'Settings for {nome}',
    'exploracao.configuracoesCartograficas': 'Cartographic settings',
    'exploracao.contadorCamadas': { um: '{quantidade} published layer', outros: '{quantidade} published layers' },
    'exploracao.contadorCamadasIndisponivel': '— published layers',
    'exploracao.consultarCatalogo': 'Reload the catalog',
    'exploracao.ordemNoMapa': 'Map order',
    'exploracao.ordemNoMapaDescricao': 'Upper layers are drawn over lower layers.',
    'exploracao.subirCamadaNome': 'Move layer {nome} up',
    'exploracao.subirCamada': 'Move layer up',
    'exploracao.descerCamadaNome': 'Move layer {nome} down',
    'exploracao.descerCamada': 'Move layer down',
    'exploracao.consultandoCatalogo': 'Loading the catalog…',
    'exploracao.nenhumaCamada': 'No layers',
    'exploracao.nenhumaCamadaTexto': 'The Geo-Engine has not published any layers in the catalog.',
    'exploracao.catalogoDeCamadas': 'Layer catalog',
    'exploracao.relevoEFerramentas': 'Terrain and tools',
    'exploracao.relevo': 'Terrain',
    'exploracao.relevoDescricao': 'Shading and intensity of the digital elevation model.',
    'exploracao.nenhumaFeicao': 'No feature selected',
    'exploracao.nenhumaFeicaoTexto': 'Select a feature in the list or on the map to inspect it.',
    'exploracao.voltarALista': 'Back to list',
    'exploracao.enquadrarFeicao': 'Fit the feature to the map',
    'exploracao.consultandoGeoEngine': 'Querying the Geo-Engine…',
    'exploracao.camadaIndisponivel': 'Layer unavailable',
    'exploracao.camadaIndisponivelTexto': 'This layer is no longer available in the Geo-Engine catalog.',
    'exploracao.voltarAoCatalogo': 'Back to catalog',
    'exploracao.resumoDe': 'Summary of {nome}',
    'exploracao.rotuloCamada': 'Layer',
    'exploracao.contadorFeicoes': { um: '{quantidade} feature', outros: '{quantidade} features' },
    'exploracao.ocultarConfiguracoes': 'Hide settings',
    'exploracao.semFamiliaGeometrica': 'Layer without a geometry family supported for visualization.',
    // --- Feature (inspection and presentation)
    'feicao.selecionada': 'Selected feature',
    'feicao.abaDetalhes': 'Details',
    'feicao.abaBuffer': 'Buffer',
    'feicao.identificador': 'Identifier',
    'feicao.geometria': 'Geometry',
    'feicao.semAtributos': 'The feature has no attributes.',
    'feicao.rotulo': 'Feature',
    'feicao.fecharSelecionada': 'Close selected feature',
    'feicao.rotuloPadrao': 'Feature {id}',
    'feicao.valorSim': 'yes',
    'feicao.valorNao': 'no',
    // --- Export (CSV and GeoJSON)
    'exportacao.geojson': 'Export GeoJSON',
    'exportacao.csv': {
        um: 'Export CSV — {quantidade} loaded',
        outros: 'Export CSV — {quantidade} loaded',
    },
    'exportacao.csvNota': 'Exports only the features loaded in this list.',
    // --- Layer (settings, summary and feature selection)
    'camada.preenchimento': 'Fill',
    'camada.corDePreenchimento': 'Fill color',
    'camada.opacidadeDoPreenchimento': 'Fill opacity',
    'camada.contorno': 'Outline',
    'camada.corDoContorno': 'Outline color',
    'camada.espessuraDoContorno': 'Outline width',
    'camada.opacidadeDoContorno': 'Outline opacity',
    'camada.linha': 'Line',
    'camada.ponto': 'Point',
    'camada.cor': 'Color',
    'camada.opacidade': 'Opacity',
    'camada.espessura': 'Width',
    'camada.tamanho': 'Size',
    'camada.rotulosGeograficos': 'Geographic labels',
    'camada.semAtributoNominal': 'This layer has no name attribute published in the tiles.',
    'camada.exibirNomesNoMapa': 'Show names on the map',
    'camada.atributoNominal': 'Attribute: {nome}',
    'camada.restaurarPadrao': 'Restore defaults',
    'camada.consultandoFicha': 'Loading summary…',
    'camada.erroTitulo': 'Error',
    'camada.estatisticasIndisponiveis': 'Could not retrieve the layer statistics.',
    'camada.falhaConsultarCamada': 'Failed to query the layer.',
    'camada.rotuloFeicoes': 'Features',
    'camada.rotuloExtensao': 'Extent',
    'camada.todos': 'All',
    'camada.recorteTitulo': 'Spatial filter',
    'camada.recorteTexto': 'Query features that intersect the visible map area.',
    'camada.recorteFiltrar': 'Filter by visible area',
    'camada.recorteRemover': 'Remove filter',
    'camada.recorteAtivo': 'Spatial filter active',
    'camada.recorteNota': 'Area captured at the moment the filter was applied.',
    'camada.recorteResultado': { um: 'Result: {quantidade} feature loaded in this filter.', outros: 'Result: {quantidade} features loaded in this filter.' },
    'camada.recorteResultadoComMais': { um: 'Result: {quantidade} feature loaded in this filter. More results can be loaded.', outros: 'Result: {quantidade} features loaded in this filter. More results can be loaded.' },
    'camada.recorteRemovido': 'Filter removed. Query restored for the whole layer.',
    'camada.erroMapaIndisponivel': 'The map is not available yet.',
    'camada.erroCoordenadasInvalidas': 'The visible map area does not have valid coordinates.',
    'camada.erroLimitesGeograficos': 'The visible area exceeds the geographic limits (longitude ±180°, latitude ±90°). Zoom in and try again.',
    'camada.erroExtensaoInvalida': 'The visible area does not define a valid extent (for example, it crosses the antimeridian).',
    'camada.buscarPorNome': 'Search feature by name',
    'camada.buscarPlaceholder': 'Search in this layer…',
    'camada.buscaIndisponivel': 'Text search is unavailable for this layer.',
    'camada.falhaConsultar': 'Failed to query features.',
    'camada.consultandoFeicoes': 'Querying features…',
    'camada.nenhumaNaArea': 'No features found in this area.',
    'camada.nenhumaEncontrada': 'No features found.',
    'camada.feicoes': 'Features',
    'camada.selecionarFeicao': 'Select {nome}',
    'camada.inspecionarFeicao': 'Inspect {nome}',
    'camada.inspecionar': 'Inspect',
    'camada.falhaCarregarMaisTitulo': 'Failed to load more features',
    'camada.falhaCarregarMais': 'Could not load more features.',
    'camada.carregarMais': 'Load more',
    // @@FRAGMENTOS@@
};
